import { BASE_URL_API } from 'constants/base-url-default'

type SignInData = {
  email: string
  password: string
}

type ChallengeParameters = object

type AuthenticationResult = {
  AccessToken: string
  ExpiresIn: number
  TokenType: string
  RefreshToken: string
  IdToken: string
}

type Root = {
  ChallengeParameters: ChallengeParameters
  AuthenticationResult: AuthenticationResult
  detail?: string
}

export const signIn = async (data: SignInData) => {
  const response = await fetch(`${BASE_URL_API}/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })

  const { AuthenticationResult } = (await response.json()) as Root

  if (response.status !== 200) {
    throw new Error('Credenciais inválidas.')
  }

  if (!AuthenticationResult.AccessToken || !AuthenticationResult.RefreshToken) {
    throw new Error('A resposta da API não contém as informações necessárias.')
  }

  const dto = {
    accessToken: AuthenticationResult.AccessToken,
    expiresIn: AuthenticationResult.ExpiresIn,
    refreshToken: AuthenticationResult.RefreshToken,
  }

  return dto
}
